<script>import { twMerge } from "tailwind-merge";
export let aClass = "flex items-center";
export let spanClass = "self-center text-2xl font-semibold whitespace-nowrap dark:text-white";
export let imgClass = "me-3 h-8";
export let href = "";
export let src = "";
export let alt = "";
export let name = "";
export let target = void 0;
let aCls = twMerge(aClass, $$props.classA);
let spanCls = twMerge(spanClass, $$props.classSpan);
let imgCls = twMerge(imgClass, $$props.classImg);
</script>

{#if href}
  <a {...$$restProps} {href} {target} class={aCls}>
    <img {src} class={imgCls} {alt} />
    <span class={spanCls}>{name}</span>
    <slot />
  </a>
{:else}
  <img {...$$restProps} {src} class={imgCls} {alt} />
{/if}

<!--
@component
[Go to docs](https://flowbite-svelte.com/)
## Props
@prop export let aClass: string = 'flex items-center';
@prop export let spanClass: string = 'self-center text-2xl font-semibold whitespace-nowrap dark:text-white';
@prop export let imgClass: string = 'me-3 h-8';
@prop export let href: string = '';
@prop export let src: string = '';
@prop export let alt: string = '';
@prop export let name: string = '';
@prop export let target: string | undefined = undefined;
-->
